import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../../../../../services/Api/Admin/adminApi";
import { GoLauncherApplicationApi } from "../../../../../../../../../../services/Api/Admin/adminTypes";
import GoLauncherApplicationForm from "../../components/GoLauncherApplicationForm";

interface MatchParams {
	applicationId: string;
}

const AdminGoLauncherApplicationsEditPage = () => {
	const { applicationId } = useParams<MatchParams>();
	const [application, setApplication] = useState<GoLauncherApplicationApi | undefined>();
	const { addFlash } = useFlash();
	const history = useHistory();
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetchApplication();
	}, []);

	const fetchApplication = async () => {
		try {
			const res = await adminApi.getGoLauncherApplication(Number(applicationId));
			setApplication(res);
			handleChangeTabTitle(
				`${t("modules.go_launcher.header.application.edit.title")} "${res.name}" | ${t(
					"lib:go_component.navigation.admin"
				)}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!application) return <LoadingContainer />;

	const goBack = () => {
		history.push("/admin/go_launcher/applications");
	};

	return (
		<div className="content">
			<Header
				back={goBack}
				title={`${t("modules.go_launcher.header.application.edit.title")} "${application.name}"`}
			/>
			<GoLauncherApplicationForm application={application} />
		</div>
	);
};

export default AdminGoLauncherApplicationsEditPage;
